import { Emitter } from '../util/event';
import CMPError from '../cmp-error';
import debug, { WARN } from '../util/debug';
import { isUndefined } from '../util/logic';
export default class API extends Emitter {
    constructor(backendBaseUrl) {
        super();
        this.backendBaseUrl = backendBaseUrl;
        this.a = {
            push: this.callQueueCommand.bind(this),
            *[Symbol.iterator]() { },
        };
    }
    static iframeHandler({ data, origin, source }) {
        if (!source) {
            return;
        }
        const msgIsString = typeof data === 'string';
        // tslint:disable-next-line:variable-name
        let __cmpCall = {};
        // tslint:disable-next-line:variable-name
        let __cmpReturn;
        try {
            // tslint:disable-next-line
            ;
            ({ __cmpCall, __cmpReturn } = msgIsString ? JSON.parse(data) : data);
        }
        catch (error) {
            debug(error, WARN);
            debug(data, WARN);
            return;
        }
        if (__cmpReturn) {
            return;
        }
        else if (!__cmpCall) {
            debug('no __cmpCall', WARN);
            return;
        }
        const { command, callId } = __cmpCall;
        let { parameter = null } = __cmpCall;
        if (isUndefined(command) || isUndefined(callId)) {
            throw new CMPError(`Missing required keys from iframe messge. Got: ${Object.keys(__cmpCall).join(', ')}`);
        }
        if (['consentToAll', 'dissentToAll'].includes(command) &&
            parameter === null) {
            parameter = origin;
        }
        const callback = (returnValue, success) => {
            const message = {
                __cmpReturn: {
                    callId,
                    returnValue,
                    success,
                },
            };
            const data = msgIsString ? JSON.stringify(message) : message;
            debug(`[${callId}] [${this.name}] responding to source`);
            debug(data);
            source.postMessage(data, '*');
        };
        debug(`[${callId}] [${this.name}] received call ${command}(${parameter})`);
        window.__uspapi(command, parameter, callback);
    }
    static provision() {
        window.__uspapi = window.__uspapi || this.provisional;
        window.__uspapi.a = window.__uspapi.a || [];
    }
    static provisional(command, parameter, callback) {
        window.__uspapi.a.push([command, parameter, callback]);
    }
    callP(command, parameter = null) {
        return new Promise((resolve, reject) => {
            this.call(command, parameter, (rtnValue, success) => {
                if (success) {
                    resolve(rtnValue);
                }
                else {
                    reject(new CMPError('Bad response'));
                }
            });
        });
    }
    callQueueCommand([command, parameter, callback]) {
        this.call(command, parameter, callback);
    }
    callQueue() {
        API.provision();
        // @ts-ignore
        for (const queueCommand of window.__uspapi.a) {
            try {
                this.callQueueCommand(queueCommand);
            }
            catch (error) {
                debug(error);
            }
        }
        window.__uspapi = this.call.bind(this);
        window.__uspapi.a = this.a;
    }
}
